import { useQuery } from "react-query"
import { AxiosResponse } from "axios"

import { IGetReservationsData, IGetReservationsQueryParams, IGetReservationsRes } from "types/reservation"

import reservationsService from "api/reservationsService"

interface IUseGetReservationsArgs {
  key: string
  getBoxInfo: boolean
  query: IGetReservationsQueryParams
  enabled?: boolean
}

const useGetReservations = ({ key, getBoxInfo, query, enabled }: IUseGetReservationsArgs) => {
  return useQuery([key, { query }], async () => {
    try {
      const res: AxiosResponse<IGetReservationsRes> = await reservationsService.getReservations(getBoxInfo ,query)

      return res.data
    }  catch (err: any) {
      return err.response
    }
  }, { enabled, refetchOnMount: false, refetchOnWindowFocus: false })
}

export default useGetReservations